import React from 'react';
import UploadPaymentproof from './UploadPaymentproof';
import AccountDetails from './AccountDetails';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { LiaTimesSolid } from 'react-icons/lia';
// import OpenandCloseModal from './OpenandCloseModal';
import { useNavigate } from 'react-router-dom';
import { getToken } from '../utils';

function Payment({ lvAccountDetails, handleOpenandCloseModal, handleToast }) {
  const [paymentProoffile, setPaymentProofFile] = useState(null);
  const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);

  const userToken = getToken()?.token;

  const navigate = useNavigate();
  const handleSubmitPayment = () => {
    setIsSubmittingPayment(true);
  };
  useEffect(() => {
    if (isSubmittingPayment) {
      const getPayment = async () => {
        try {
          await axios.post(
            `${process.env.REACT_APP_BASE_URL}/payments/proof`,
            {
              payment_id: lvAccountDetails?.payment?.id,
              cx_transaction_id: lvAccountDetails?.cx?.id,
              offer_owner_id: lvAccountDetails?.payment?.offer_owner?.id,
              image: paymentProoffile,
            },

            {
              headers: {
                Authorization: `Bearer ${userToken}`,
                'Content-Type': 'multipart/form-data',
              },
            }
          );
          handleToast(
            'success',
            'Payment uploaded succesfully,you will be niotify onece payment is confirmed'
          );
          handleOpenandCloseModal('close');
          setIsSubmittingPayment(null);
          navigate('/transactionrequest');
        } catch (error) {
          setIsSubmittingPayment(null);
          handleToast('error', 'An error occured please try again');
        }
      };
      getPayment();
    }
  }, [
    userToken,
    isSubmittingPayment,
    lvAccountDetails?.cx?.id,
    lvAccountDetails?.payment?.id,
    lvAccountDetails?.payment?.offer_owner?.id,
    paymentProoffile,
    handleToast,
    handleOpenandCloseModal,
    navigate,
  ]);

  return (
    <section className='flex flex-col top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 gap-6 bg-p-wh shadow-lg max-w-md py-8 rounded relative'>
      <h2 className='text-[18px] font-semibold border-b-hf pb-2  px-6'>
        Loyaltyview Account Details
      </h2>
      <span
        className='absolute right-6 top-6 text-2xl  text-s-bk cursor-pointer hover:text-p-bk'
        onClick={() => handleOpenandCloseModal('close')}
      >
        <LiaTimesSolid />
      </span>
      <div className='mx-6'>
        {' '}
        <AccountDetails lvAccountDetails={lvAccountDetails} />
      </div>

      <div className='bg-f-bk p-4 mx-6'>
        <UploadPaymentproof setPaymentProofFile={setPaymentProofFile} />
      </div>

      <button
        type='button'
        className='text-p-wh justify-center  mx-6 disabled:text-f-bk hover:bg-b-mc/75 focus:bg-b-mc/80 px-8 w-ful py-2 disabled:bg-b-mct bg-b-mc rounded relative'
        disabled={paymentProoffile === null}
        onClick={handleSubmitPayment}
      >
        Payment Completed
      </button>
    </section>
  );
}

export default Payment;
